import React from "react";

const FolderRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5151 5.39995L9.93496 3.36566C9.69577 2.52692 8.77821 2.02917 7.88553 2.25391L3.44062 3.37296C2.54795 3.5977 2.01819 4.45982 2.25738 5.29856L3.66494 10.2342C3.90413 11.073 4.82169 11.5707 5.71437 11.346L6.19995 11.2237M10.5151 5.39995H7.79995C6.91629 5.39995 6.19995 6.1163 6.19995 6.99995V11.2237M10.5151 5.39995H12.1999C13.0836 5.39995 13.7999 6.1163 13.7999 6.99995V12.1999C13.7999 13.0836 13.0836 13.7999 12.1999 13.7999H7.79995C6.91629 13.7999 6.19995 13.0836 6.19995 12.1999V11.2237",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FolderRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;